import * as React from 'react';

import { Root } from './styled';


export type LinkProps = {
	to: string;
	color?: 'black' | 'primary' | 'muted';
	noHover?: boolean;
	component?: any;
	style?: React.CSSProperties;
} & React.HTMLProps<Omit<HTMLAnchorElement, 'href' | 'color'>>;

const Link: React.SFC<LinkProps> = React.forwardRef((props, ref) => {
	const {
		to,
		component,
		children,
		...rest
	} = props;
	const dynamicProps = {
		[component === 'a' ? 'href' : 'to']: to
	};

	return (
		<Root
			as={component}
			ref={ref}
			{...rest}
			{...dynamicProps as any}>
			{children}
		</Root>
	);
});

Link.displayName = 'Link';
Link.defaultProps = {
	color: 'primary',
	component: 'a',
};

export default Link;
